import React from "react";

export function PageHeader({ eyebrow, title, description, actions }) {
  return (
    <div className="bg-card border-b border-border">
      <div className="px-8 py-6 flex items-end justify-between gap-6">
        <div>
          {eyebrow && <div className="overline mb-2">{eyebrow}</div>}
          <h1 className="text-3xl font-bold leading-tight tracking-tight text-foreground">
            {title}
          </h1>
          {description && (
            <p className="mt-2 text-sm text-muted-foreground max-w-2xl">
              {description}
            </p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}

export function PageBody({ children }) {
  return <div className="p-8 space-y-6">{children}</div>;
}

export function Stat({ label, value, sub, testId, icon: Icon, tone }) {
  const toneClass =
    tone === "positive"
      ? "text-primary"
      : tone === "negative"
      ? "text-destructive"
      : "text-foreground";
  return (
    <div
      data-testid={testId}
      className="qb-card p-5 flex flex-col gap-2"
    >
      <div className="flex items-center justify-between">
        <div className="overline">{label}</div>
        {Icon && (
          <div className="w-8 h-8 rounded-md bg-primary/10 text-primary flex items-center justify-center">
            <Icon size={16} weight="fill" />
          </div>
        )}
      </div>
      <div className={`text-2xl font-bold leading-none tracking-tight num ${toneClass}`}>
        {value}
      </div>
      {sub && <div className="text-xs text-muted-foreground num">{sub}</div>}
    </div>
  );
}

export function fmtMoney(n, currency = "USD") {
  const SYM = { USD: "$", NGN: "\u20a6", EUR: "\u20ac", GBP: "\u00a3" };
  const v = Number(n || 0);
  const sign = v < 0 ? "-" : "";
  const abs = Math.abs(v).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${sign}${SYM[currency] || ""}${abs}`;
}
